import { render } from "./skeleton.vue?vue&type=template&id=00581ea7&scoped=true"
const script = {}

import "./skeleton.vue?vue&type=style&index=0&id=00581ea7&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00581ea7"]])

export default __exports__